import { Component } from '@angular/core';

@Component({
    selector: 'app-partner-terms-page',
    templateUrl: './partner-terms-page.component.html',
    styleUrls: ['./partner-terms-page.component.scss'],
    standalone: false
})
export class PartnerTermsPageComponent {

}
